import { MUITab } from "@abb/arcadia-ui-react"
import { useContext, useEffect, useState } from "react"
import { Navigate, useNavigate, useParams } from "react-router-dom"
import { digitalManagerApi } from "../../../../../services/api"
import {
  DiMaDetailsHeader,
  DiMaDetailsHeaderProps,
} from "../../../../components/DiMaDetailsHeader"
import { DiMaProgress } from "../../../../components/DiMaProgress"
import { UserContext } from "../../../../context/UserContext"
import { FileVersionGet } from "../../../../models/FileVersion"
import { useHashTab } from "../../../../../hooks/useHashTab"
import { FileVersionDetails } from "./details_tab/FileVersionDetails"

export function FileVersionContainer() {
  const { user, isLoadingUser } = useContext(UserContext)
  const { fileId, versionId } = useParams()
  const navigate = useNavigate()
  const { activeTab, handleTabChange } = useHashTab("details")

  const [version, setVersion] = useState<FileVersionGet>()
  const returnURL = `/files/${fileId}#versions`

  useEffect(() => {
    if (fileId && versionId) {
      digitalManagerApi
        .get<FileVersionGet>(`/files/${fileId}/versions/${versionId}`)
        .then((res) => {
          setVersion(res.data)
        })
        .catch(() => {
          navigate(returnURL)
        })
    }
  }, [fileId, navigate, returnURL, versionId])

  if (!fileId || !versionId) {
    return <Navigate to={returnURL} />
  }

  if (!version || isLoadingUser || !user) {
    return <DiMaProgress />
  }

  const detailsHeaderProps: DiMaDetailsHeaderProps = {
    url: returnURL,
    title: `${version.file.name}${version.suffix ? version.suffix : ""}.${
      version.file.extension
    }`,
    label: "File",
    subtitle: `${version.file.name}.${version.file.extension}`,
    hideCopyToClipboard: true,
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
      <DiMaDetailsHeader {...detailsHeaderProps} />
      <MUITab
        tabItems={[{ id: "details", label: "Details" }]}
        value={activeTab}
        handleChange={handleTabChange}
      />
      {activeTab === "details" && (
        <FileVersionDetails
          version={version}
          fileId={fileId}
          user={user}
          setVersion={setVersion}
        />
      )}
    </div>
  )
}
